"use client";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";
import { segmentEvent } from "@/utils/segmentfunctions";

import { HomepageHeroImageLifestage, HomepageHeroImageTab } from "./HomepageHeroImage.types";

type HomepageHeroImageTabsProps = {
  tabs: HomepageHeroImageTab[];
  active: HomepageHeroImageLifestage;
  setter: (value: HomepageHeroImageLifestage) => void;
};

const HomepageHeroImageTabs = ({ tabs, active, setter }: HomepageHeroImageTabsProps) => {
  const changeTab = (value: HomepageHeroImageLifestage, text: string) => {
    segmentEvent("Modal Tab Clicked", {
      module_location: "mid_fold",
      text,
    });
    setter(value);
  };

  return (
    <div className="relative z-[1] flex w-full flex-row justify-center gap-2 xl:flex-col">
      {tabs.map((tab) => {
        const selected = tab.value === active;
        return (
          <button
            key={tab.value}
            type="button"
            aria-label={tab.label}
            aria-current={selected ? "true" : undefined}
            className={cn(
              "h-[34px] w-1/3 max-w-[96px] px-3 md:h-[42px] md:max-w-[120px]",
              "xl:h-14 xl:w-full xl:max-w-[171px] xl:px-6 rounded",
              "bg-nova-base-white transition-colors hover:bg-nova-brand-accent-100",
              "active:bg-nova-base-black active:[&_.textelement]:text-nova-base-white",
              selected && "bg-nova-brand-accent-80 pointer-events-none"
            )}
            onClick={() => changeTab(tab.value, tab.label)}
          >
            <TextElementNova
              text={tab.label}
              className={cn(
                "CTA-20-Dia-Normal",
                selected ? "text-nova-base-black" : "text-nova-transparency-black-60"
              )}
            />
          </button>
        );
      })}
    </div>
  );
};

export default HomepageHeroImageTabs;
